import React, { FC, useEffect, useState } from 'react';

import { TableBody } from '@material-ui/core';

import { IHoleResult } from '../../../../../../store/admin/holeResults/store';

import { useAssignResultsState } from '../../AssignResults/Context/AssignResults.context';
import ResultsTableRow from './ResultsTableRow';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { sortBy } from '../../../../../../contrib/sortBy';
import { getCTPHoleWinner } from '../../AssignResults/Context/Utils/getCTPHoleWinner';

const CTPTableBody: FC = () => {
  const { roundId } = useRouteInfoState();
  const { ctpResults, selectedCombination } = useAssignResultsState();

  const [selectedHoles, setSelectedHoles] = useState<number[]>([]);

  useEffect(() => {
    if (selectedCombination && selectedCombination.format.metadata && roundId) {
      setSelectedHoles(selectedCombination.format.metadata[Number(roundId)]);
    }
  }, [roundId, selectedCombination]);

  const [selectedHolesResults, setSelectedHolesResults] = useState<IHoleResult[]>([]);

  useEffect(() => {
    if (selectedCombination && selectedHoles.length > 0 && Object.keys(ctpResults).length > 0) {
      const newSelectedHolesResults = selectedHoles
        .flatMap(hole =>
          ctpResults[Number(Number(hole) - 1)]
            ? getCTPHoleWinner(
                ctpResults[Number(Number(hole) - 1)],
                selectedCombination.format.considerFlights,
                selectedCombination.format.adjustedHandicap
              )
            : undefined
        )
        .filter(Boolean);

      const sortedNewSelectedHolesResults = sortBy(newSelectedHolesResults, 'asc', 'hole');

      setSelectedHolesResults(sortedNewSelectedHolesResults);
    }
  }, [selectedHoles, ctpResults, selectedCombination]);

  return (
    <TableBody className="results-table-table-body">
      {selectedHolesResults.map((result, index: number) => (
        <ResultsTableRow
          key={`${index}-${result.flightId}`}
          result={result}
          showNoPosition={true}
          ctpResult={true}
        />
      ))}
    </TableBody>
  );
};

export default CTPTableBody;
